// pages/CreateUserPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { 
    CheckCircle,
    AlertCircle
} from 'lucide-react';
import '../create_user/CreateUserPage.css';
import DashboardBase  from "../DashboardBase";
import FundSearch from '../../components/FundManagerSearch';
import UserSearch from '../../components/UserSearch';

const CreateAssignPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedFund, setSelectedFund] = useState(null);
    

    const handleUserSelect = (user) => {
        // Call your fetchTransactions with the selected fund
        setSelectedUser(user);
    };

    const handleFundSelect = (fund) => {
        // Call your fetchTransactions with the selected fund
        setSelectedFund(fund);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {

            const token = localStorage.getItem('token');
            const formData = {
                user_id: selectedUser.id,
                fund_manager_id: selectedFund.fund_manager_id,
                operation: "ADD",
            };
            console.log(formData);

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/fund-manager-assign`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to create user');
            }

            setSuccess(true);
            setTimeout(() => {
                navigate('/users');
            }, 2000);

        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
     <DashboardBase
     page="home"
     content= { 
        <div className="create-user-page"> 
            <div className="dashboard-page">
            <div className="dashboard-header">
                <h1>Assign Fund Manager to Fund</h1>
            </div>

            <div className="content-card">
                {success ? (
                    <div className="success-message">
                        <CheckCircle className="success-icon" />
                        <p>User assigned successfully! Redirecting...</p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="create-user-form">
                        {error && (
                            <div className="error-message">
                                <AlertCircle className="error-icon" />
                                {error}
                            </div>
                        )}
                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="email">Users</label>
                                <UserSearch onUserSelect={handleUserSelect} role="FUND_MANAGER" />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="first_name">Fund Manager</label>
                                <FundSearch onFundSelect={handleFundSelect} />
                            </div>
                        </div>

                        <div className="form-actions">
                            <button 
                                type="button" 
                                className="button secondary"
                                onClick={() => navigate('/users')}
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit" 
                                className="button primary"
                                disabled={loading}
                            >
                                {loading ? 'Creating...' : 'Create Assignment'}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
        </div>
        }
        />
    );
};

export default CreateAssignPage;